import React from 'react'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import {
  Box,
  Typography,
  Grid,
  TextField,
  MenuItem
} from '@mui/material'

const McTransportStrategy = [
  { label: 'SMTP', value: 'SMTP' },
  { label: 'SMTPS', value: 'SMTPS' },
  { label: 'SMTP_TLS', value: 'SMTP_TLS' },
  { label: 'SMTP_OAUTH2', value: 'SMTP_OAUTH2' }
]

const SenderInformationFields = ({ control, errors }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="subtitle1" sx={{ mb: 2.5, color: 'text.primary' }}>
        {t('mailTemplate.users.modal.senderInformation')}
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Controller
            name="smtpHostName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.smtpHostName')}
                placeholder={t('mailTemplate.users.modal.smtpHostNameP')}
                {...(errors.smtpHostName && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.smtpHostName')
                })}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="smtpPort"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.smtpPort')}
                placeholder={t('mailTemplate.users.modal.smtpPortP')}
                type="number"
                {...(errors.smtpPort && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.smtpPort')
                })}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="transportStrategy"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                select
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.transportStrategy')}
                defaultValue=""
                {...(errors.transportStrategy && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.transportStrategy')
                })}
              >
                {McTransportStrategy.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default SenderInformationFields
